function maybeInvoke(props, property) {
  return typeof property === 'function'
    ? property(props)
    : property;
}

export default function(mobileProperty, tabletProperty) {
  return function(props) {
    if (props.theme === undefined) {
      throw new Error("Property \"theme\" not found in given props. Either provide it or wrap the component in `withTheme()`.");
    }

    switch (true) {
      case props.theme.isMobile: return maybeInvoke(props, mobileProperty);
      case props.theme.isTablet: return maybeInvoke(props, tabletProperty);
      default: return null;
    }
  }
}
